import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["id"];
var _hoisted_2 = ["for"];
import { watch, computed, toRef } from "vue";
import { useStore } from "@/store";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Switch',
    props: {
        bindValue: Boolean,
        componentSize: String,
        atChange: Function,
    },
    emits: ["update:bind-value"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var emit = __emit;
        var store = useStore();
        var switchComponentID = Array.from({ length: 6 }, function () {
            return String.fromCharCode(Math.floor(Math.random() * 62) + (Math.random() < 0.5 ? 65 : 97));
        }).join(""); // 生成随机6位字符串作为 id
        // TODO: 值未发生改变，开关不触发
        var props = __props;
        var bindValue = toRef(props.bindValue);
        var atChangeFunc = props.atChange;
        // if (atChangeFunc) {
        //   watch(
        //     () => bindValue,
        //     (newValue) => {
        //       atChangeFunc(newValue);
        //     }
        //   );
        // }
        watch(bindValue, function (newValue) {
            // 当 bindValue 发生变化时，触发 update:bind-value 事件
            emit("update:bind-value", newValue); // 双向绑定受控，发送事件使得传来的值能发生变化
            if (atChangeFunc) {
                atChangeFunc(newValue);
            }
        });
        var switchStyleVariant = computed(function () { return ({
            "--switch-size": props.componentSize || "3rem",
        }); });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: "switch-component-container",
                style: _normalizeStyle(switchStyleVariant.value)
            }, [
                _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "switch-componenet-".concat(_unref(switchComponentID)),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((bindValue).value = $event); })
                }, null, 8, _hoisted_1), [
                    [_vModelCheckbox, bindValue.value]
                ]),
                _createElementVNode("label", {
                    for: "switch-componenet-".concat(_unref(switchComponentID))
                }, "Toggle", 8, _hoisted_2)
            ], 4));
        };
    }
});
